<template>
  <div class="flex">
    <div :class="[
      'w-6 h-6 won-tag-light-gray rounded-l-md border-r border-[#DBDBDC]',
      'cursor-pointer flex items-center justify-center select-none',
    ]" @click="builderStyle.zoomOut">
      <svg xmlns="http://www.w3.org/2000/svg" class="won-color-gray stroke-2 w-4 h-4" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 12h-15" />
      </svg>
    </div>

    <div :class="[
      'w-[46px] h-6 flex items-center cursor-pointer',
      'justify-center select-none won-tag-light-gray',
    ]" @click="builderStyle.resetZoom">
      <div class="text-sm won-color-gray">{{ zoom }}%</div>
    </div>

    <div :class="[
      'w-6 h-6 won-tag-light-gray rounded-r-md border-l border-[#DBDBDC]',
      'cursor-pointer flex items-center justify-center select-none',
    ]" @click="builderStyle.zoomIn">
      <svg xmlns="http://www.w3.org/2000/svg" class="won-color-gray stroke-2 w-4 h-4" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
      </svg>
    </div>

  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { useBuilderStyles } from '../../store/builder-style.store'

import LensMinus from '../../icons/lens-minus.vue'
import LensPlus from '../../icons/lens-plus.vue'

const builderStyle = useBuilderStyles()
const { zoom } = storeToRefs(builderStyle)
</script>
